import { useEffect, useRef } from 'react';
import { useBannerStore } from '@/state/bannerStore';
import { useOffersWaiting } from './queries';

/**
 * Wherever the member is in the app: how many offers on their posts they have not opened yet (for the badge on
 * Browse), and a banner when more arrive while the app is open. Offers already waiting when the app opened are the
 * badge's job, not a banner's. The banner opens the post when the new offers are on one post, My posts otherwise.
 */
export function useOffersWatcher(): number {
  const { data } = useOffersWaiting();
  const previous = useRef<number | null>(null);

  useEffect(() => {
    if (!data) return;
    const before = previous.current;
    previous.current = data.unseen;
    if (before === null || data.unseen <= before) return;
    const withNew = Object.entries(data.byPost)
      .filter(([, counts]) => counts.unseen > 0)
      .map(([postId]) => postId);
    useBannerStore.getState().showOffers({
      count: data.unseen - before,
      postId: withNew.length === 1 ? (withNew[0] ?? null) : null,
    });
  }, [data]);

  return data?.unseen ?? 0;
}
